<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1">
      <mat-card-title class="">Fornecedor também ser Cliente</mat-card-title>
    </div>
    <button mat-flat-button class="btn-tg-cancel w-1/12" (click)="close()">Voltar</button>
    <button mat-flat-button class="btn-tg w-1/12" [disabled]="!checkInvalidForm()" (click)="transformClient()">
      @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
        Concluir
      }
    </button>
  </mat-card-header>

  <div class="mt-4 mb-2"></div>

  @if (!loadingScreen) {
    <mat-accordion multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title> <h4>Cliente</h4> </mat-panel-title>
        </mat-expansion-panel-header>

        <div [formGroup]="formLegalEntity">
          <div class="flex justify-between gap-4 items-center">
            <mat-form-field class="input-tg w-4/12" appearance="outline">
              <mat-label>Nome</mat-label>
              <input matInput formControlName="name" readonly />
            </mat-form-field>

            <mat-form-field class="input-tg w-5/12" appearance="outline">
              <mat-label>Razão social</mat-label>
              <input matInput formControlName="corporate_name" readonly />
            </mat-form-field>

            <mat-form-field class="input-tg w-3/12" appearance="outline">
              <mat-label>CNPJ</mat-label>
              <input matInput formControlName="cnpj" [mask]="'99.999.999/9999-99'" readonly />
            </mat-form-field>
          </div>
          <div class="flex justify-between gap-4 items-center">
            <mat-form-field class="input-tg w-6/12" appearance="outline">
              <mat-label>Inscrição Estadual</mat-label>
              <input matInput formControlName="reg_state" readonly />
            </mat-form-field>

            <mat-form-field class="input-tg w-6/12" appearance="outline">
              <mat-label>Inscrição Municipal</mat-label>
              <input matInput formControlName="reg_municipal" readonly />
            </mat-form-field>
          </div>
        </div>

        <mat-divider></mat-divider>
        <p class="mt-2">
          Endereços, contatos, dados bancários, forma de pagamento, documento fiscal e responsáveis são dados da empresa
          e continuam os mesmos — o cadastro de fornecedor não é alterado.
        </p>
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="panelFinancial = true">
        <mat-expansion-panel-header>
          <mat-panel-title> <h4>Financeiro</h4> </mat-panel-title>
        </mat-expansion-panel-header>
        @if (panelFinancial) {
          <div [formGroup]="formFinancial">
            <div class="flex justify-between gap-4 items-center">
              <mat-slide-toggle
                class="input-tg w-2/12 p-bottom-toggle px-2"
                formControlName="tgmob"
                (change)="onChangeSelect($event)"
              >
                {{ formFinancial.get('tgmob')?.value ? 'tg.mob' : 'Cliente' }}</mat-slide-toggle
              >
              <mat-form-field class="input-tg w-2/12" appearance="outline">
                <mat-label>Comissão</mat-label>
                @if (formFinancial.get('commission')!.value != '') {
                  <span matTextSuffix>%&nbsp;</span>
                }
                <input matInput formControlName="commission" decimalInput />
              </mat-form-field>
              <mat-form-field class="input-tg w-2/12" appearance="outline">
                <mat-label>Divisor</mat-label>
                <input matInput formControlName="divider" decimalInput />
              </mat-form-field>
              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Taxa</mat-label>
                @if (formFinancial.get('tax')!.value != '') {
                  <span matTextSuffix>%&nbsp;</span>
                }
                <input matInput formControlName="tax" currencyInput />
              </mat-form-field>
              <div class="w-8/12"></div>
            </div>
          </div>
        }
      </mat-expansion-panel>
    </mat-accordion>
  } @else {
    <div class="m-auto">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  }
</mat-card>
